import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import styles from "./tab-group.module.scss";

const TabGroup: React.FC<{
  labels: React.ReactNode[];
  panels: React.ReactNode[];
}> = ({ labels, panels }) => {
  return (
    <Tab.Group>
      <Tab.List className={styles.tabList}>
        {labels.map((label) => (
          <Tab key={`tab-group-label-${label}`} as={Fragment}>
            <div className={styles.tabListItem}>{label}</div>
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels>
        {panels.map((panel, index) => (
          <Tab.Panel key={`tab-group-panel-${labels[index]}`}>
            {panel}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};
export default TabGroup;
